import { render, staticRenderFns } from "./OnboardingLinkedAccounts.vue?vue&type=template&id=55adfd81"
import script from "./OnboardingLinkedAccounts.vue?vue&type=script&lang=ts"
export * from "./OnboardingLinkedAccounts.vue?vue&type=script&lang=ts"
import style0 from "./OnboardingLinkedAccounts.vue?vue&type=style&index=0&id=55adfd81&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports